export {InviteMembersModalConnected as InviteMembersModal} from './invite_members_modal_connected';
